export default "__VITE_ASSET__DW9Amc_P__"